import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/internal/operators/mergeMap';
import { switchMap } from 'rxjs/operators';

import { updateTimeZoneGroups } from '../../actions/common';
import {
    OPEN_TIME_TARGETING_EDITOR,
    OpenTimeTargetingEditor,
    updateTimeTargetingEditor
} from '../../actions/timeTargetingEditor';
import { getTimeTargetingEditorDataFromTimeTargetingValue } from '../../mappers/campaignsEdit/campaignsEdit';
import { EpicDeps } from '../../service/StoreFactory';
import { State } from '../../typings/state';
import { TimeZoneGroup } from '../../typings/timeTargetingEditor';

export const openTimeTargetingEditorEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(OPEN_TIME_TARGETING_EDITOR),
        switchMap(
            (action: OpenTimeTargetingEditor): Observable<Action> => {
                const state = store$.value;
                const { login, timeZoneGroups } = state.commonData;
                const { editorId, savedValue } = action;
                const editorData = getTimeTargetingEditorDataFromTimeTargetingValue(
                    savedValue
                );

                if (timeZoneGroups !== undefined) {
                    return of(updateTimeTargetingEditor(editorId, editorData));
                }

                return from(
                    deps.campaignsDataProvider.getTimeZoneGroups(login)
                ).pipe(
                    mergeMap((timeZoneGroupsData: TimeZoneGroup[]) => {
                        return [
                            updateTimeZoneGroups(timeZoneGroupsData),
                            updateTimeTargetingEditor(editorId, editorData)
                        ];
                    })
                );
            }
        )
    );
};
